var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#17B26A",
  d: "M10 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--bg-primary)",
  strokeWidth: 1.5,
  d: "M10 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/online.4df20094fcec86dfa8dbdcf67f00daf0.svg";